<template>
	<AppModal v-bind="$attrs" :class="`modal--${character?.bg}`" class="character-modal">
		<div class="character-modal__content">
			<div class="character-modal__main">
				<div class="character-modal__image">
					<div class="character-modal__image-wrapper">
						<img :src="character?.image?.url2" :alt="$t(character?.name)" />
					</div>
				</div>

				<h2 class="character-modal__title text-black m-0">
					{{ $t(character?.name) }}
				</h2>

				<p class="character-modal__subtitle text-black m-0">
					{{ $t('landing.modals.character.subtitle') }}
				</p>
			</div>

			<div class="character-modal__body">
				<div class="character-modal__body-wrapper">
					<h3 class="character-modal__title m-0">
						{{ $t('landing.modals.character.title') }}
					</h3>

					<div class="character-modal__desc rich-text" v-html="$t(character?.desc)"></div>
				</div>
			</div>
		</div>
	</AppModal>
</template>

<script>
import AppModal from '@/components/landing/AppModal.vue'

export default {
	name: 'CharacterModal',
	components: {
		AppModal
	},
	props: {
		character: {
			type: [Object, null],
			required: true
		}
	}
}
</script>
